import { render, staticRenderFns } from "./social.vue?vue&type=template&id=9ff6cb48&scoped=true"
import script from "./social.vue?vue&type=script&lang=js"
export * from "./social.vue?vue&type=script&lang=js"
import style0 from "./social.vue?vue&type=style&index=0&id=9ff6cb48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff6cb48",
  null
  
)

export default component.exports